import EsusView from 'components/esus/EsusView'

export default function CadastroDomiciliarTerritorialView() {
  return <EsusView url='/pec/user/relatorios/consolidados/cadastroDomiciliar' />
}
